/* Vendens Campaign Grid — JavaScript Logic */

(function() {
  function initCampaignGrid() {
    // 1. Marquee Track Cloning
    document.querySelectorAll('[data-marquee]').forEach(function (track) {
      if (track.children.length > 0 && !track.dataset.initialized) {
        track.innerHTML += track.innerHTML;
        track.dataset.initialized = 'true';
      }
    });

    // 2. Scroll Animation Observer
    if (!window.VendensCampaignObserver) {
      window.VendensCampaignObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { 
            e.target.classList.add('v-animate-active'); 
          } else {
            // Optional: remove if you want animation to re-trigger
            // e.target.classList.remove('v-animate-active'); 
          }
        });
      }, { rootMargin: '0px 0px -50px 0px', threshold: 0.1 });
    }

    document.querySelectorAll('.v-animate-scroll').forEach(function (el) { 
      window.VendensCampaignObserver.observe(el); 
    });
  }

  // Initialize on load and Shopify Editor events
  document.addEventListener('DOMContentLoaded', initCampaignGrid);
  document.addEventListener('shopify:section:load', initCampaignGrid);
})();
